import React from 'react'
import './ProgressBar.scss'

export default function ProgressBar({ progress }) {
  return (
    <div
      className={`progress-bar${progress > 0 ? '' : ' progress-bar--hidden'}`}
    >
      <span className='progress-bar__label'>{`${progress}%`}</span>
      <div style={{ width: `${progress}%` }} className='progress-bar__filler' />
    </div>
  )
}
